import { c as create_ssr_component, g as getContext, s as spread, a as escape_attribute_value, b as escape_object, d as add_attribute, e as escape, v as validate_component, f as createEventDispatcher, i as each } from "../../../../chunks/ssr.js";
import { C as CardLayout } from "../../../../chunks/CardLayout.js";
import { B as Button } from "../../../../chunks/Button.js";
import { C as Card } from "../../../../chunks/Card.js";
import { c as compute_rest_props } from "../../../../chunks/utils.js";
import { twMerge } from "tailwind-merge";
import { C as ClockOutline } from "../../../../chunks/ClockOutline.js";
import { H as Heading } from "../../../../chunks/Heading.js";
import { f as formatCurrency } from "../../../../chunks/currency.js";
import dayjs from "dayjs";
const CalendarMonthOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "calendar month outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Zm3-7h.01v.01H8V13Zm4 0h.01v.01H12V13Zm4 0h.01v.01H16V13Zm-8 4h.01v.01H8V17Zm4 0h.01v.01H12V17Zm4 0h.01v.01H16V17Z"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Zm3-7h.01v.01H8V13Zm4 0h.01v.01H12V13Zm4 0h.01v.01H16V13Zm-8 4h.01v.01H8V17Zm4 0h.01v.01H12V17Zm4 0h.01v.01H16V17Z"></path></svg>`} `;
});
const FileLinesOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "file lines outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"></path></svg>`} `;
});
const UsersGroupOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "users group outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M4.5 17H4a1 1 0 0 1-1-1 3 3 0 0 1 3-3h1m0-3.05A2.5 2.5 0 1 1 9 5.5M19.5 17h.5a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-1m0-3.05a2.5 2.5 0 1 0-2-4.45m.5 13.5h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1Zm-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M4.5 17H4a1 1 0 0 1-1-1 3 3 0 0 1 3-3h1m0-3.05A2.5 2.5 0 1 1 9 5.5M19.5 17h.5a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-1m0-3.05a2.5 2.5 0 1 0-2-4.45m.5 13.5h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1Zm-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"></path></svg>`} `;
});
const SalesCardIcons = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { cardIcon } = $$props;
  if ($$props.cardIcon === void 0 && $$bindings.cardIcon && cardIcon !== void 0) $$bindings.cardIcon(cardIcon);
  return `${cardIcon === "Jahresumsatz" ? `${validate_component(CalendarMonthOutline, "CalendarMonthOutline").$$render($$result, { class: "text-primary-600 w-20 h-20" }, {}, {})}` : `${cardIcon === "Garantie" ? `${validate_component(ClockOutline, "ClockOutline").$$render($$result, { class: "text-primary-600 w-20 h-20" }, {}, {})}` : `${cardIcon === "Volumen" ? `${validate_component(UsersGroupOutline, "UsersGroupOutline").$$render($$result, { class: "text-primary-600 w-20 h-20" }, {}, {})}` : `${cardIcon === "Exklusivität" ? `${validate_component(FileLinesOutline, "FileLinesOutline").$$render($$result, { class: "text-primary-600 w-20 h-20" }, {}, {})}` : ``}`}`}`}`;
});
const SalesCard = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { card } = $$props;
  createEventDispatcher();
  if ($$props.card === void 0 && $$bindings.card && card !== void 0) $$bindings.card(card);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Card, "Card").$$render(
      $$result,
      {
        class: "w-full max-w-full flex flex-col items-center gap-y-4 " + (card.selected ? "" : "")
      },
      {},
      {
        default: () => {
          return `${validate_component(SalesCardIcons, "SalesCardIcons").$$render($$result, { cardIcon: card.cardIcon }, {}, {})} <h3 class="text-2xl leading-7 text-neutral-600">${escape(card.name)}</h3> <div class="text-center text-neutral-600">${escape(card.tagline)}</div> <div class="grid h-[300px] place-items-start">${each(card.options, (option) => {
            return `${validate_component(Button, "Button").$$render(
              $$result,
              {
                color: "none",
                class: "hover:bg-primary-600 " + (card.valueSelected === option.value ? "bg-primary-600 text-white hover:text-white" : ""),
                value: option.value
              },
              {
                value: ($$value) => {
                  option.value = $$value;
                  $$settled = false;
                }
              },
              {
                default: () => {
                  return `<!-- HTML_TAG_START -->${option.value}<!-- HTML_TAG_END --> `;
                }
              }
            )}`;
          })}</div>`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
let rdsPrice = 35.91;
let shkPrice = 33.11;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let total;
  let selectedCards = [
    {
      name: "Jahresumsatz",
      cardIcon: "Jahresumsatz",
      tagline: "Erlöse im gesamten Kalenderjahr",
      options: [
        { value: "50.000 | 3,0%", percentage: 3 },
        { value: "100.000 | 4,0%", percentage: 4 },
        { value: "250.000 | 5,0%", percentage: 5 },
        { value: "500.000 | 6,0%", percentage: 6 },
        { value: "999.000 | 7,0%", percentage: 7 }
      ],
      selected: false,
      valueSelected: ""
    },
    {
      name: "Garantie",
      cardIcon: "Garantie",
      tagline: "Schichtgarantie die Woche",
      options: [
        {
          value: "1d*5 pax / weekly / 44w | 1,0%",
          percentage: 1
        },
        {
          value: "2d*5 pax / weekly / 44w | 2,0%",
          percentage: 2
        },
        {
          value: "3d*5 pax / weekly / 44w | 3,0%",
          percentage: 3
        },
        {
          value: "4d*5 pax / weekly / 44w | 4,0%",
          percentage: 4
        },
        {
          value: "5d*5 pax / weekly / 44w | 7,0%",
          percentage: 7
        }
      ],
      selected: false,
      valueSelected: ""
    },
    {
      name: "Volumen",
      tagline: "Veranstaltungsvolumen im Jahr",
      cardIcon: "Volumen",
      options: [
        {
          value: "6 VA p.a > 5.000 &euro; | 3,0%",
          percentage: 3
        },
        {
          value: "12 VA p.a > 5.000 &euro; | 4,0%",
          percentage: 4
        },
        {
          value: "18 VA p.a > 5.000 &euro; | 5,0%",
          percentage: 5
        },
        {
          value: "24 VA p.a > 5.000 &euro; | 6,0%",
          percentage: 6
        },
        {
          value: "36 VA p.a > 5.000 &euro; | 7,0%",
          percentage: 7
        }
      ],
      selected: false,
      valueSelected: ""
    },
    {
      name: "Exklusivität",
      tagline: "exklusive Rahmenvereinbarung",
      cardIcon: "Exklusivität",
      options: [{ value: "7,0%", percentage: 7 }],
      selected: false,
      valueSelected: ""
    }
  ];
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    total = selectedCards.reduce(
      (acc, card) => {
        if (card.selected) {
          const index = card.options.findIndex((x) => x.value === card.valueSelected);
          return acc + card.options[index].percentage;
        }
        return acc;
      },
      0
    ) || 0;
    $$rendered = `${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: "recrew Sonderkonditionen " + dayjs().year(),
        className: "flex flex-col"
      },
      {},
      {
        default: () => {
          return `<div class="w-4/5 mx-auto">${validate_component(Heading, "Heading").$$render($$result, { tag: "h3", class: "text-neutral-600" }, {}, {
            default: () => {
              return `Preis- und Leistungsübersicht ${escape(dayjs().year())}`;
            }
          })} <span class="text-lg" data-svelte-h="svelte-n4c1lu">Unit Service München</span> <div class="flex flex-row flex-1 justify-between gap-3 mt-6 text-xl mb-5" data-svelte-h="svelte-151vat"><span><span class="text-slate-400">*re</span>crew Überlassung von</span> <span>Preis</span></div> <div class="flex flex-col my-4" data-svelte-h="svelte-1xhq358"><div class="flex flex-row flex-1 justify-between font-extrabold"><span>Veranstaltungsleiter (VAL) *5</span> <span>á 53,54 € Std.</span></div> <ul class="list-disc"><li class="ml-8">fachgeschult / mit Top Referenzen für Restaurant, Catering &amp;
                    Event</li> <li class="ml-8">führt VA eigenverantwortlich durch &amp; weist alle Gewerke an</li> <li class="ml-8">recrew outfit VAL: Anzug 3-teilig schwarz,</li></ul> <span class="ml-8">Hemd/Bluse weiß, Krawatte schwarz, Schuhe schwarz</span></div> <div class="flex flex-col my-4 " data-svelte-h="svelte-dqgrs6"><div class="flex flex-row flex-1 justify-between font-extrabold"><span>Oberkellner (OKE) *4</span> <span>á 49,87 € Std.</span></div> <ul class="list-disc"><li class="ml-8">geschult mit Referenzen | &gt;3 Jahre Berufserfahrung</li> <li class="ml-8">verantwortet alle Stationen | koordiniert / weist CDS/CDB
                    (Küche) an</li> <li class="ml-8">recrew outfit OKE: Anzug 2-teilig schwarz,</li></ul> <span class="ml-8">Hemd/Bluse weiß, Krawatte schwarz, Schuhe schwarz</span></div> <div class="flex flex-col my-4" data-svelte-h="svelte-gtg5bp"><div class="flex flex-row flex-1 justify-between font-extrabold"><span>Chef de Service (CDS) oder Demi de Bar (DDB) *3</span> <span>á 41,66 € Std.</span></div> <ul class="list-disc"><li class="ml-8">versiert / geschult | 1 Jahre Berufserfahrung &gt;30 Events</li> <li class="ml-8">verantwortet eigene Station | koordiniert / weist SHK/RDS an</li> <li class="ml-8">recrew outfit CDS/DDB: Hemd/Bluse weiß, Schuhe schwarz</li></ul> <span class="ml-8">Hose schwarz, Schuhe schwarz</span></div> <div class="flex flex-col my-4"><div class="flex flex-row flex-1 justify-between font-extrabold"><span data-svelte-h="svelte-ft5vq2">Recrew Demi Service (RDS) *2</span> <span>á ${escape(formatCurrency(rdsPrice))} Std.</span></div> <ul class="list-disc" data-svelte-h="svelte-1hshysc"><li class="ml-8">versiert / geschult | &gt;3 Monate recrew mit Erfahrung &gt;20
                    Events</li> <li class="ml-8">koordiniert Menü und Getränkeservice / weist Teams bis 4
                    SHK. an</li> <li class="ml-8">recrew outfit RDS: Hemd/Bluse weiß, Hose schwarz, Schuhe
                    schwarz</li></ul> <span class="ml-8" data-svelte-h="svelte-1e47eyc">Hose schwarz, Schuhe schwarz</span></div> <div class="flex flex-col my-4"><div class="flex flex-row flex-1 justify-between font-extrabold"><span data-svelte-h="svelte-1torb7f">Servicehilfskraft (SHK) *1</span> <span>á ${escape(formatCurrency(shkPrice))} Std.</span></div> <ul class="list-disc" data-svelte-h="svelte-1a20n1"><li class="ml-8">Einsteiger | geschult und geübt</li> <li class="ml-8">geübt in Getränke- &amp; Menüservice</li> <li class="ml-8">recrew outfit SHK: Hemd/Bluse weiß, Hose schwarz, Schuhe
                    schwarz</li></ul> <span class="ml-8" data-svelte-h="svelte-1e47eyc">Hose schwarz, Schuhe schwarz</span></div> <p class="mb-4 mt-5" data-svelte-h="svelte-quxd0x">Abgerechnet werden die tatsächlich geleisteten Stunden im
            Viertelstunden-Takt. Es gilt eine Mindesteinsatzzeit von 6 Stunden
            pro Einsatz.</p></div> <div class="grid grid-cols-4 gap-5 w-4/5 mx-auto py-6">${each(selectedCards, (card) => {
            return `${validate_component(SalesCard, "SalesCard").$$render(
              $$result,
              { card },
              {
                card: ($$value) => {
                  card = $$value;
                  $$settled = false;
                }
              },
              {}
            )}`;
          })}</div>  <div class="w-4/5 mx-auto"><div class="flex flex-row flex-1 justify-between gap-3 mt-3 text-xl mb-5" data-svelte-h="svelte-1x9l4g2"><span>Discount Übersicht</span> <span>%</span></div> ${each(selectedCards.filter((card) => card.selected), (card) => {
            return `<div class="flex flex-col my-4 rounded"><div class="flex flex-row flex-1 justify-between "><span>${escape(card.name)} <!-- HTML_TAG_START -->${card.valueSelected}<!-- HTML_TAG_END --></span> <span>${escape(card.valueSelected.split("|")[1] || card.valueSelected)} </span></div> </div>`;
          })} <div class="flex flex-col my-4 rounded"><div class="flex flex-row flex-1 justify-between "><span data-svelte-h="svelte-15szm80">Gesamtdiscount</span> <span class="font-semibold text-primary-600">${escape(total)}%</span></div></div></div> <div class="w-4/5 mx-auto"><div class="flex flex-row flex-1 justify-between gap-3 mt-3 text-xl mb-5" data-svelte-h="svelte-1mg163g"><span><span class="text-slate-400">*re</span>crew Überlassung von</span> <span>Preis</span></div> <div class="flex flex-col my-4 rounded"><div class="flex flex-row flex-1 justify-between "><span data-svelte-h="svelte-ft5vq2">Recrew Demi Service (RDS) *2</span> <span>á ${escape(formatCurrency(rdsPrice))} Std.</span></div> <p class="w-full text-right text-primary-600 font-extrabold">*DISCOUNT ${escape(formatCurrency(rdsPrice * (100 - total) / 100))} Std.</p></div> <div class="flex flex-col my-4"><div class="flex flex-row flex-1 justify-between"><span data-svelte-h="svelte-1torb7f">Servicehilfskraft (SHK) *1</span> <span>á ${escape(formatCurrency(shkPrice))} Std.</span></div> <p class="w-full text-right font-extrabold text-primary-600">*DISCOUNT ${escape(formatCurrency(shkPrice * (100 - total) / 100))} Std.</p></div></div> <div class="w-4/5 mx-auto pt-6" data-svelte-h="svelte-sbefl6"><h3 class="text-neutral-600 text-xl">Zuschläge Nacht, Sonn- und Feiertage</h3> <p class="my-2">Für Einsätze zwischen 22:00 und 06:00 wird für alle in diesem Zeitraum geleisteten Stunden ein Aufschlag von 10% auf den jeweiligen Stundenpreis erhoben.</p> <p class="my-2">Für Einsätze an Sonntagen wird, für alle an diesen Tagen geleisteten Stunden, ein Aufschlag von 20% auf den jeweiligen Stundenpreis erhoben.</p> <p class="my-2">Für Einsätze an Feiertagen wird, für alle an diesen Tagen geleisteten Stunden, ein Aufschlag von 50% auf den jeweiligen Stundenpreis erhoben.</p> <h5 class="text-neutral-600 text-xl">Alle Preise verstehen sich zzgl. 19 % USt.</h5></div>`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
